module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/creditos/verde/detalles/components/avaluo/verde-avaluo.component.scss
// module id = ./src/app/creditos/verde/detalles/components/avaluo/verde-avaluo.component.scss
// module chunks = main